import { PlatformCreateApp } from '@data/_generated-api/platform-api/models/platform-create-app';
import { ModelFieldConfig } from '@/types/model.types';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';

const defaultFormConfig: ModelFieldConfig<EgiAppEntity>[] = [
  {
    fieldGroupClassName: 'row',
    fieldGroup: [
      {
        className: 'col-6',
        key: 'name',
        type: 'input',
        templateOptions: {
          label: 'Naam',
          required: true,
          maxLength: 32
        },
        focus: true
      },
      {
        className: 'col-6',
        key: 'rootNavigationItem.name',
        type: 'input',
        templateOptions: {
          required: true,
          label: 'Weergave in menu',
          maxLength: 32
        }
      }
    ]
  },
  {
    className: 'mt-5',
    type: 'textarea',
    key: 'info',
    templateOptions: {
      required: false,
      label: 'Beschrijving'
    }
  },
  {
    type: 'egi-page-select',
    key: 'rootNavigationItem.pageComponentId',
    templateOptions: {
      required: true,
      label: 'Home pagina'
    }
  }
];

export const egiAppCreateConfig: ModelFieldConfig<PlatformCreateApp>[] = [...defaultFormConfig];
